import * as M from './Main.style';

const Main = () => {
    return (
        <M.Wrapper>
            <M.Title>펫이닷 관리자 페이지</M.Title>
            <M.SubTitle>ADMIN PAGE</M.SubTitle>
        </M.Wrapper>
    );
};

export default Main;
